import { TabletTabs } from './TabletTabs'
export default TabletTabs
